// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"5669e9a9","703":"6ca298f5"}[chunkId] + ".chunk.js";
};